export const LAW_CONETNT = [
	{
		id: "1-law",
		title: "Taryfikatory",
		links: [
			{
				id: "1-tar",
				name: "TARYFIKATOR",
				path: "/documents/taryfikator-pdf.pdf",
			},
		],
	},
	{
		id: "2-law",
		title: "Akty prawne Unia Europejska",
		links: [
			{
				id: "1-ue",
				name: "Rozporządzenie (WE) nr 561/2006",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02006R0561-20200820",
			},
			{
				id: "2-ue",
				name: "Rozporządzenie Parlamentu Europejskiego i Rady (EU) nr 165/2014",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02014R0165-20200820",
			},
			{
				id: "3-ue",
				name: "Rozporządzenie Komisji (UE) nr 581/2010 dot. częstotliwości pobierania danych",
				path: "https://eur-lex.europa.eu/legal-content/PL/ALL/?uri=CELEX%3A32010R0581",
			},
			{
				id: "4-eu",
				name: "Umowa AETR",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20140000409",
			},
			{
				id: "5-eu",
				name: "Dyrektywa 2002/15/WE",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02002L0015-20020323",
			},
			{
				id: "6-eu",
				name: "Rozporządzenie (WE) nr 1071/2009",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02009R1071-20220221",
			},
			{
				id: "7-eu",
				name: "Rozporządzenie (WE) nr 1072/2009",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02009R1072-20220221",
			},
			{
				id: "8-eu",
				name: "Rozporządzenie (WE) nr 1073/2009",
				path: "https://eur-lex.europa.eu/legal-content/PL/ALL/?uri=CELEX%3A32009R1073",
			},
			{
				id: "9-eu",
				name: "Parlamentu Europejskiego i Rady (EU) nr 165/2014",
				path: "https://eur-lex.europa.eu/legal-content/PL/TXT/?uri=CELEX%3A02014R0165-20200820",
			},
		],
	},
	{
		id: "3-law",
		title: "Akty prawne Polska",
		links: [
			{
				id: "1-pl",
				name: "Ustawa o czasie pracy kierowców",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20040920879",
			},
			{
				id: "2-pl",
				name: "Rozporządzenie o należnościach z tytułu podróży służbowej",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20220001481",
			},
			{
				id: "3-pl",
				name: "kodeks pracy",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19740240141",
			},
			{
				id: "4-pl",
				name: "Kodeks karny",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19970880553",
			},
			{
				id: "5-pl",
				name: "Ustawa o wynagrodzeniu minimalnym",
				path: "https://isap.sejm.gov.pl/isap.nsf/download.xsp/WDU20022001679/U/D20021679Lj.pdf",
			},
			{
				id: "6-pl",
				name: "Rozporządzenie o wynagrodzeniu minimalnym 2022",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20210001690",
			},
			{
				id: "7-pl",
				name: "Ustawa o transporcie drogowym",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20011251371",
			},
			{
				id: "8-pl",
				name: "Ustawa o systemie tachografów cyfrowych",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20180001480",
			},
			{
				id: "9-pl",
				name: "Rozporządzenie – Ocena ryzyka",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20190002123",
			},
			{
				id: "10-pl",
				name: "Ustawa o drogach publicznych",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU19850140060",
			},
			{
				id: "11-pl",
				name: "Rozporządzenie dotyczące ograniczeń zakazów ruchu",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20210000783",
			},
			{
				id: "12-pl",
				name: "Rozporządzenie dotyczące warunków technicznych oraz wyposażenia",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20220000122",
			},
			{
				id: "13-pl",
				name: "Rozporządzenie uzyskiwania certyfikatów zawodowych",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=WDU20170001352",
			},
			{
				id: "14-pl",
				name: "Wyjaśnienie świadectwa działalności",
				path: "https://www.gov.pl/web/gitd/nowy-wzor-zaswiadczenia-o-dzialalnosci",
			},
			{
				id: "15-pl",
				name: "Ustawa o Państwowej Inspekcji Pracy",
				path: "https://isap.sejm.gov.pl/isap.nsf/DocDetails.xsp?id=wdu20070890589",
			},
		],
	},
];
